import Bubble from './Bubble';
import End from './End';
import Image from './Image';
import ImageQuizImage from './ImageQuizImage';
import InteractiveActivity from './InteractiveActivity';
import OrderingAnswer from './InteractiveActivity/OrderingAnswer';
import Question from './InteractiveActivity/Question';
import QuestionCountHeader from './InteractiveActivity/Question/QuestionCountHeader';
import Intro from './Intro';
import LearningOutcomes from './LearningOutcomes';
import Meta from './Meta';
import ProgressButton from './ProgressButton';
import ImageSlide from './Slides/ImageSlide';
import LearningOutcomesSlide from './Slides/LearningOutcomesSlide';
import PreviewNavButton from './Slides/PreviewNavButton';
import ResultsSlide from './Slides/ResultsSlide';
import TextSlide from './Slides/TextSlide';
import TaskBox from './TaskBox';
import Text from './Text';
import Video from './Video';

export default {
  Bubble,
  End,
  Image,
  ImageQuizImage,
  InteractiveActivity,
  Intro,
  LearningOutcomes,
  Meta,
  OrderingAnswer,
  ProgressButton,
  Question,
  QuestionCountHeader,
  Text,
  TaskBox,
  Video,
  TextSlide,
  ImageSlide,
  LearningOutcomesSlide,
  ResultsSlide,
  PreviewNavButton,
};
